import React, { useState, useEffect } from 'react';

const steps = [
  'Analyzing your LinkedIn profile...',
  'Scraping your website content...',
  'Identifying your target audience...',
  'Determining your core service...',
  'Extracting proof points...',
  'Generating headline options...',
  'Writing your new bio...',
  'Creating your audit deck...'
];

function Loading() {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStep((prev) => (prev + 1) % steps.length);
    }, 2500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh]">
      {/* Animated Logo/Spinner */}
      <div className="relative w-24 h-24 mb-8">
        <div className="absolute inset-0 border-4 border-amber-400/30 rounded-full"></div>
        <div className="absolute inset-0 border-4 border-transparent border-t-amber-400 rounded-full animate-spin"></div>
        <div className="absolute inset-4 border-4 border-transparent border-t-purple-500 rounded-full animate-spin" style={{ animationDirection: 'reverse', animationDuration: '1.5s' }}></div>
      </div>

      {/* Status Text */}
      <div className="text-center">
        <h2 className="text-2xl font-bold text-white mb-4">Generating Your Audit</h2>
        <p className="text-amber-400 text-lg animate-pulse">
          {steps[step]}
        </p>
      </div>

      {/* Progress Dots */}
      <div className="flex gap-2 mt-8">
        {steps.map((_, i) => (
          <div
            key={i}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              i <= step ? 'bg-amber-400' : 'bg-slate-600'
            }`}
          />
        ))}
      </div>

      <p className="text-slate-500 text-sm mt-8">
        This usually takes 30-60 seconds
      </p>
    </div>
  );
}

export default Loading;